/**
 * Plugin identifiers.
 *
 * Kept in a dependency-free leaf module so that consumers which only need the
 * identifiers (e.g. plugin-metadata.ts) do not pull in PluginConfigService and
 * its transitive imports, which would form an import cycle.
 */
export const PluginIdentifier = {
  DATABANK: "eodhd",
  CREDIT: "credit",
  TRANSACTION: "transaction",
  MONTHLY_SUMMARY: "monthly-summary",
  AUTO_BUDGET: "auto-budget",
} as const;

export type PluginIdentifierType = (typeof PluginIdentifier)[keyof typeof PluginIdentifier];
